import { DateFormat, LocalizedDatetimeOptions, TimeFormat, localizeDateTime } from 'utils/l10n';
import {
  FORMAT_COMPONENTS_WITH_FULL_DATE,
  FORMAT_COMPONENTS_WITH_MILITARY_TIME,
  FORMAT_COMPONENTS_WITH_NUMERIC_DATE,
  FORMAT_COMPONENTS_WITH_TIMEZONE_OFFSET,
  FORMAT_COMPONENTS_WITH_SHORT_DATE,
  FORMAT_COMPONENTS_WITH_TIME,
  FORMAT_COMPONENTS_WITH_TWELVE_HOUR_TIME,
} from './constants';

const shouldShowTime = (format: string) => FORMAT_COMPONENTS_WITH_TIME.some(format.includes);

const shouldShowOffset = (format: string) =>
  FORMAT_COMPONENTS_WITH_TIMEZONE_OFFSET.some((offsetComponent) =>
    format.includes(offsetComponent),
  );

const getDateStyle = (format: string) => {
  if (FORMAT_COMPONENTS_WITH_FULL_DATE.some(format.includes)) return DateFormat.Full;

  if (
    FORMAT_COMPONENTS_WITH_NUMERIC_DATE.some(format.includes) &&
    !FORMAT_COMPONENTS_WITH_SHORT_DATE.some(format.includes)
  )
    return DateFormat.Numeric;

  return DateFormat.Short;
};

const getTimeStyle = (format: string) => {
  if (FORMAT_COMPONENTS_WITH_MILITARY_TIME.some((timeComponent) => format.includes(timeComponent)))
    return TimeFormat.Military;

  if (
    FORMAT_COMPONENTS_WITH_TWELVE_HOUR_TIME.some((timeComponent) => format.includes(timeComponent))
  )
    return TimeFormat.TwelveHour;
};

const convertLegacyFormatToDateTimeOptions = (
  legacyFormat?: string,
  options?: LocalizedDatetimeOptions,
): LocalizedDatetimeOptions => ({
  showTime: legacyFormat ? shouldShowTime(legacyFormat) : undefined,
  showOffset: legacyFormat ? shouldShowOffset(legacyFormat) : undefined,
  dateStyle: legacyFormat ? getDateStyle(legacyFormat) : undefined,
  timeStyle: legacyFormat ? getTimeStyle(legacyFormat) : undefined,
  ...options,
});

export const displayDateWithLocalization = (
  inputDate: Date,
  format?: string,
  options?: LocalizedDatetimeOptions,
) => {
  const dateTimeOptions = convertLegacyFormatToDateTimeOptions(format, options);
  return localizeDateTime(inputDate, dateTimeOptions);
};
